import { Tooltip, Popover } from 'bootstrap'

import $ from "jquery";
window.$ = window.jQuery = $;

$(document).ready(function (){
  // Bootstrap 5 popovers
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
  const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))

  // Bootstrap 5 tooltips
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
});